export const isTestDevice = async () => false

export default {
  isTestDevice,
}
